import { render, staticRenderFns } from "./receipt-information.vue?vue&type=template&id=0cee198d&scoped=true"
import script from "./receipt-information.vue?vue&type=script&lang=js"
export * from "./receipt-information.vue?vue&type=script&lang=js"
import style0 from "./receipt-information.vue?vue&type=style&index=0&id=0cee198d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cee198d",
  null
  
)

export default component.exports